<template>
  <div class="pc-container">
    <header class="pc-header">{{ test_report_project_name }}测试报告</header>
    <main class="pc-main flex">
      <div class="student-box flex">
        <div class="userinfo-box">
          <div class="avatar-box">
            <img class="avatar-icon" :src="student_info.avatar" alt="" />
            <img class="sex-icon" :src="sexImgList[student_info.gender]" alt="" />
          </div>
          <span>{{ student_info.name }}</span>
        </div>
        <div class="class-box flex">
          <div>
            <span>班级</span>
            <span class="class-text">{{ student_info.class_title }}</span>
          </div>
          <div>
            <span>学号</span>
            <span class="studentNum-text">{{ student_info.student_number }}</span>
          </div>
        </div>
        <div class="achievement">
          <div class="main-item">
            <p>测试成绩</p>
            <div>
              <span>{{ test_result_info.number }}</span>
              <span>{{ test_result_info.unit }}</span>
            </div>
          </div>
          <div class="detail-box flex">
            <div class="detail-item">
              <img src="@/assets/imgs/score_icon.png" alt="" />
              <div>
                <span>{{ test_result_info.score }}</span>
                <span>分数</span>
              </div>
            </div>
            <div class="detail-item">
              <img src="@/assets/imgs/level_icon.png" alt="" />
              <div>
                <span>{{ test_result_info.level }}</span>
                <span>等级</span>
              </div>
            </div>
            <div class="detail-item">
              <img src="@/assets/imgs/grade_icon.png" alt="" />
              <div>
                <span>{{ test_result_info.grade_rank }}</span>
                <span>年级排名</span>
              </div>
            </div>
            <div class="detail-item">
              <img src="@/assets/imgs/class_icon.png" alt="" />
              <div>
                <span>{{ test_result_info.class_rank }}</span>
                <span>班级排名</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sport-box">
        <div class="top-content flex">
          <div
            class="sport-parmas"
            v-for="(item, index) in test_report_parameters"
            :key="index"
          >
            <span>{{ item.name }}</span>
            <span>{{ item.value }}</span>
          </div>
        </div>
        <div class="bottom-content flex">
          <div class="left-box">
            <!-- 运动曲线 -->
            <div class="sport-echart" v-if="test_report_chart_data.length != 0">
              <div class="top-box">
                <div class="title-box">
                  <img src="@/assets/imgs/sport_echart_icon.png" alt="" />
                  <span>运动曲线</span>
                </div>
                <div class="tags-box" v-if="test_report_project_name != '跳绳'">
                  <div>
                    <span class="tag-icon tag-icon-good"></span>
                    <span>上升时间</span>
                  </div>
                  <div>
                    <span class="tag-icon tag-icon-bad"></span>
                    <span>下降时间</span>
                  </div>
                </div>
              </div>
              <div class="canvas-box" id="echarts-line-pc" />
            </div>
            <!-- 测试点评 -->
            <div
              class="test-comment"
              :class="
                test_report_chart_data.length != 0
                  ? 'test-comment-height-fix'
                  : 'test-comment-height-flex'
              "
            >
              <div class="title-box">
                <img src="@/assets/imgs/test_comment_icon.png" alt="" />
                <span>测试点评</span>
              </div>
              <div class="content-box">
                <div class="comment-good flex" v-if="test_report_comment[0]">
                  <div class="left">
                    <img src="@/assets/imgs/comment_good_icon.png" alt="" />
                    <span>做的很棒!</span>
                  </div>
                  <p class="wrap-text">{{ test_report_comment[0] }}</p>
                </div>
                <div class="comment-bad flex" v-if="test_report_comment[1]">
                  <div class="left">
                    <img src="@/assets/imgs/comment_bad_icon.png" alt="" />
                    <span>有待提高!</span>
                  </div>
                  <p class="wrap-text">{{ test_report_comment[1] }}</p>
                </div>
              </div>
            </div>
            <div class="sport-screenshot flex" v-if="test_report_screenshots && test_report_screenshots.length">
              <img
                class="swiper-button-prev"
                src="@/assets/imgs/report_screenshots_left_icon.png"
                alt=""
              />
              <swiper ref="mySwiper" :options="swiperOptions" class="screenshot-box">
                <swiper-slide
                  v-for="(item, index) in test_report_screenshots"
                  :key="index"
                >
                  <img :src="item.value" alt="" />
                  <div class="screenshot-tag">
                    <span>{{ item.name }}</span>
                  </div>
                </swiper-slide>
              </swiper>
              <img
                class="swiper-button-next"
                src="@/assets/imgs/report_screenshots_right_icon.png"
                alt=""
              />
            </div>
          </div>
          <div class="right-box">
            <div class="title-box">
              <img src="@/assets/imgs/muscle_icon.png" alt="" />
              <span>肌群状态</span>
            </div>
            <div class="tags-box">
              <div>
                <span class="tag-icon tag-icon-good"></span>
                <span>状态良好</span>
              </div>
              <div>
                <span class="tag-icon tag-icon-bad"></span>
                <span>有待加强</span>
              </div>
            </div>
            <div class="content-box">
              <div class="img-box">
                <img :src="test_report_muscles.muscles_img_src" alt="" />
              </div>
              <p class="wrap-text">{{ test_report_muscles.comment }}</p>
            </div>
          </div>
        </div>
      </div>
    </main>
    <el-dialog
      :visible.sync="dialogTableVisible"
      @close="closeDialog"
      :show-close="false"
      :modal="false"
    >
      <div class="el-sport-screenshot flex">
        <img
          class="el-swiper-button-prev"
          src="@/assets/imgs/report_screenshots_left_icon.png"
          alt=""
        />
        <swiper ref="elSwiper" :options="dialogSwiperOptions" class="el-screenshot-box">
          <swiper-slide v-for="(item, index) in test_report_screenshots" :key="index">
            <img :src="item.value" alt="" />
            <div class="el-screenshot-tag">
              <span>{{ item.name }}</span>
            </div>
          </swiper-slide>
        </swiper>
        <img
          class="el-swiper-button-next"
          src="@/assets/imgs/report_screenshots_right_icon.png"
          alt=""
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
let vm = null;

export default {
  name: "",
  components: { swiper, swiperSlide },
  props: ["reportData"],
  data() {
    return {
      swiperOptions: {
        autoplay: false,
        slidesPerView: 4, //设置slider容器能够同时显示的slides数量
        spaceBetween: 30, // 轮播元素的间隔
        allowTouchMove: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //点击回调
        on: {
          tap: function () {
            if (this.clickedIndex != undefined) {
              vm.dialogTableVisible = true;
              vm.$nextTick(() => {
                vm.$refs.elSwiper.swiper.slideTo(this.clickedIndex + 1, 1000, true);
              });
            }
          },
        },
      },

      dialogTableVisible: false, //弹窗
      //弹窗的轮播
      dialogSwiperOptions: {
        autoplay: false,
        initialSlide: 0, //设定初始化时slide的索引。
        loop: true,
        allowTouchMove: false,
        effect: "fade",
        navigation: {
          nextEl: ".el-swiper-button-next",
          prevEl: ".el-swiper-button-prev",
        },
      },

      sexImgList: [
        "",
        require("@/assets/imgs/sex_boy.png"),
        require("@/assets/imgs/sex_girl.png"),
      ],
      test_report_project_name: "",
      student_info: {},
      test_report_chart_data: [],
      test_report_comment: [],
      test_report_muscles: {},
      test_report_parameters: [],
      test_report_screenshots: [],
      test_result_info: {},

      echart_sports_line_canvas: "",
      echart_sports_line_one_color: [
        "rgba(0,126,255,1)",
        "rgba(0,126,255,.3)",
        "rgba(0,126,255,.1)",
      ],
      echart_sports_line_two_color: [
        "rgba(255,211,67,1)",
        "rgba(255,211,67,.3)",
        "rgba(255,211,67,.1)",
      ],
      xAxisUnit: "个", //项目为跳绳时  s
      yAxisUnit: "s", //项目为跳绳时  个
    };
  },
  created() {
    vm = this;
  },
  mounted() {},
  methods: {
    //轮播弹窗关闭
    closeDialog() {
      this.dialogTableVisible = false;
    },
    getReportData() {
      this.test_report_project_name = this.reportData.test_report_project_name;
      this.student_info = this.reportData.student_info;
      this.test_report_chart_data = this.reportData.test_report_chart_data;
      this.test_report_comment = this.reportData.test_report_comment;
      this.test_report_muscles = this.reportData.test_report_muscles;
      this.test_report_parameters = this.reportData.test_report_parameters;
      this.test_report_screenshots = this.reportData.test_report_screenshots;
      this.test_result_info = this.reportData.test_result_info;

      this.$nextTick(() => {
        this.setDocumentTitle();
        this.echart_sports_line();
      });
    },

    setDocumentTitle() {
      var title = this.student_info.name + "的测试报告";
      document.title = title;
    },

    // 各项目运动占比
    echart_sports_line() {
      var test_report_project_name = this.test_report_project_name;
      this.echart_sports_line_canvas = echarts.init(
        document.getElementById("echarts-line-pc")
      );
      const xAxisData = [];
      for (let i = 0; i < this.test_report_chart_data[0].length; i++) {
        if (test_report_project_name == "跳绳") {
          xAxisData.push(i * 5);
        } else {
          xAxisData.push(i);
        }
      }

      var option;
      option = {
        tooltip: {
          trigger: "axis",
          formatter(params) {
            if (params.length == 1) {
              return `<div>第${params[0].axisValueLabel}秒</div>
                  <div>${params[0].marker}跳绳个数：${params[0].data}个</div>`;
            }
            if (params.length == 2) {
              return `<div>第${params[0].axisValueLabel}个</div>
                  <div>${params[0].marker}上升时间：${params[0].data}秒</div>
                  <div>${params[1].marker}下降时间：${params[1].data}秒</div>`;
            }
          },
        },
        grid: {
          top: 40,
          bottom: 40,
          left: 30,
          right: 30,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          //刻度
          axisTick: {
            show: false,
          },
          //grid区域分割线
          splitLine: {
            show: true,
          },
          data: xAxisData,
          name: this.test_report_project_name == "跳绳" ? this.yAxisUnit : this.xAxisUnit,
        },
        yAxis: {
          type: "value",
          //grid区域分割线
          splitLine: {
            show: false,
          },
          name: this.test_report_project_name == "跳绳" ? this.xAxisUnit : this.yAxisUnit,
          nameTextStyle: {
            align: "right",
          },
          axisLine: {
            show: true,
          },
        },
        series: [
          {
            itemStyle: {
              color: this.echart_sports_line_one_color[0],
            },
            data: this.test_report_chart_data[0],
            type: "line",
            symbol: "circle",
            symbolSize: 10,
            areaStyle: {
              opacity: 1,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: this.echart_sports_line_one_color[0], // 0% 处的颜色
                  },
                  {
                    offset: 0.7,
                    color: this.echart_sports_line_one_color[1], // 70% 处的颜色
                  },
                  {
                    offset: 1,
                    color: this.echart_sports_line_one_color[2], // 100% 处的颜色
                  },
                ],
              },
            },
          },
          {
            itemStyle: {
              color: this.echart_sports_line_two_color[0],
            },
            data: this.test_report_chart_data[1] ? this.test_report_chart_data[1] : [],
            type: "line",
            symbol: "circle",
            symbolSize: 10,
            areaStyle: {
              opacity: 1,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: this.echart_sports_line_two_color[0], // 0% 处的颜色
                  },
                  {
                    offset: 0.7,
                    color: this.echart_sports_line_two_color[1], // 70% 处的颜色
                  },
                  {
                    offset: 1,
                    color: this.echart_sports_line_two_color[2], // 100% 处的颜色
                  },
                ],
              },
            },
          },
        ],
      };
      option && this.echart_sports_line_canvas.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
// @import './base.scss';
.pc-container {
  width: 100%;
  height: 100%;
  color: #100f48;
  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog__body {
    padding: 0;
  }
  /deep/ .el-dialog {
    background: transparent;
    box-shadow: none;
    width: 1060px;
    margin: 0 auto;
  }
}

/deep/ .el-dialog__wrapper {
  z-index: 0 !important;
}

.pc-header {
  height: 72px;
  line-height: 72px;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}
.pc-main {
  width: 1920px;
  padding: 28px 40px 50px;
  background: #f5f6fa;
}
.student-box {
  width: 397px;
  height: 930px;
  background: #ffffff;
  box-shadow: 0px 1px 4px 1px #e5e9f2;
  border-radius: 16px;
  margin-right: 16px;
  flex-direction: column;
  .userinfo-box {
    .avatar-box {
      position: relative;
      width: 147px;
      height: 147px;
      margin: 75px auto 0;
      .avatar-icon {
        position: absolute;
        width: 147px;
        height: 147px;
        border-radius: 50%;
      }
      .sex-icon {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 36px;
        height: 36px;
      }
    }
    span {
      display: block;
      text-align: center;
      margin: 18px 0;
      font-size: 38px;
      font-weight: 600;
    }
  }
  .class-box {
    flex-direction: column;
    justify-content: space-between;
    width: 358px;
    height: 174px;
    padding: 36px 24px;
    margin: 0 auto;
    background: #f4f5fe;
    border-radius: 16px;
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 30px;
      }
      span:nth-child(1) {
        font-weight: bold;
      }
      .class-text{
        font-size: 24px;
      }
      .studentNum-text{
        font-size: 20px;
      }
    }
  }
  .achievement {
    .main-item {
      text-align: center;
      margin: 36px auto;
      font-weight: bold;
      p {
        font-family: pingFangMedium;
        font-size: 32px;
        margin-bottom: 8px;
      }
      span:nth-child(1) {
        font-size: 46px;
      }
      span:nth-child(2) {
        font-size: 22px;
        margin-left: 8px;
      }
    }
    .detail-box {
      margin: 0 20px;
      justify-content: space-between;
      flex-wrap: wrap;
      .detail-item {
        display: flex;
        align-items: center;
        width: 171px;
        height: 99px;
        background: linear-gradient(180deg, #679cf6 0%, #4072ee 100%);
        border-radius: 16px;
        margin-bottom: 16px;
        padding: 0 15px;
        img {
          width: 38px;
          height: 38px;
          // margin-left: 15px;
        }
        div {
          width: 100%;
          display: flex;
          flex-direction: column;
          color: #ffffff;
          text-align: center;
          span:nth-child(1) {
            font-size: 32px;
            font-weight: bold;
          }
          span:nth-child(2) {
            font-size: 14px;
          }
        }
      }
    }
  }
}

.sport-box {
  flex: 1;
}

.top-content {
  width: 100%;
  height: 161px;
  margin-bottom: 16px;
  background: #ffffff;
  box-shadow: 0px 1px 4px 1px #e5e9f2;
  border-radius: 16px;

  .sport-parmas {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    border-right: 2px solid #ebeef5;
    span:nth-child(1) {
      font-size: 22px;
      margin-top: 11px;
    }
    span:nth-child(2) {
      font-size: 40px;
      margin-top: 27px;
      font-weight: 600;
    }
  }
  .sport-parmas:last-child {
    border: none;
  }
}
.bottom-content {
  flex: 1;
  .left-box {
    display: flex;
    flex-direction: column;
    margin-right: 16px;
    .sport-echart {
      width: 1034px;
      height: 263px;
      background: #ffffff;
      box-shadow: 0px 1px 4px 1px #e5e9f2;
      border-radius: 16px;
      margin-bottom: 16px;
      padding: 16px;

      .top-box {
        display: flex;
        justify-content: space-between;
        .tags-box {
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          width: 173px;
          height: 31px;
          background: linear-gradient(180deg, #679cf6 0%, #4072ee 100%);
          border-radius: 10px;
          font-size: 12px;
          color: #ffffff;
          div {
            display: flex;
            align-items: center;
            .tag-icon {
              width: 8px;
              height: 8px;
              border-radius: 8px;
              margin-right: 8px;
            }
            .tag-icon-good {
              background: #22e1ff;
            }
            .tag-icon-bad {
              background: #ffd343;
            }
          }
        }
      }
      .canvas-box {
        width: 100%;
        height: 100%;
      }
    }
    .test-comment-height-flex {
      flex: 1;
    }
    .test-comment-height-fix {
      height: 327px;
    }
    .test-comment {
      display: flex;
      flex-direction: column;
      width: 1034px;
      background: #ffffff;
      box-shadow: 0px 1px 4px 1px #e5e9f2;
      border-radius: 16px;
      margin-bottom: 12px;
      padding: 16px;

      .content-box {
        flex: 1;
        overflow: scroll;
        overflow-x: hidden;
        margin-top: 25px;
        .comment-bad {
          margin-top: 30px;
        }
        .left {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 38px;
          img {
            width: 48px;
            height: 48px;
          }
          span {
            font-size: 12px;
            color: #f09636;
            white-space: nowrap;
          }
        }
      }
      .content-box::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 4px;
      }
      .content-box::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 5px;
        -webkit-box-shadow: inset005pxrgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
      }
      // .content-box::-webkit-scrollbar-track {
      //   /*滚动条里面轨道*/
      //   -webkit-box-shadow: inset005pxrgba(0, 0, 0, 0.2);
      //   border-radius: 0;
      //   background: rgba(0, 0, 0, 0.1);
      // }
    }
    .sport-screenshot {
      position: relative;
      width: 1034px;
      height: 135px;
      img {
        position: absolute;
        width: 30px;
        height: 48px;
      }
      .swiper-button-prev {
        position: absolute;
        left: 0;
      }
      .swiper-button-next {
        position: absolute;
        right: 0;
      }
      .screenshot-box {
        position: relative;
        width: 934px;
        height: 135px;
        .swiper-slide {
          position: relative;
          height: 135px;
          margin-right: 30px;
          border: 1px solid #4072ee;
          box-sizing: border-box;
          img {
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
          .screenshot-tag {
            position: absolute;
            left: 0;
            bottom: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 5px 20px;
            background: #4072ee;
            border-radius: 0 4px 0 0;
            color: #ffffff;
            span {
              display: inline-block;
              font-size: 10px;
              color: #ffffff;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }

  .right-box {
    width: 377px;
    height: 753px;
    background: #ffffff;
    box-shadow: 0px 1px 4px 1px #e5e9f2;
    border-radius: 16px;
    padding: 16px;
    .tags-box {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 100%;
      height: 47px;
      margin-top: 19px;
      background: linear-gradient(180deg, #679cf6 0%, #4072ee 100%);
      border-radius: 10px;
      font-size: 16px;
      color: #ffffff;
      div {
        display: flex;
        align-items: center;
        .tag-icon {
          width: 8px;
          height: 8px;
          border-radius: 8px;
          margin-right: 8px;
        }
        .tag-icon-good {
          background: #fa8b25;
        }
        .tag-icon-bad {
          background: #85cff9;
        }
      }
    }
    .img-box {
      width: 100%;
      padding: 20px 10px;
      margin-top: 23px;
      margin-bottom: 14px;
      background: #f4f5fe;
      border-radius: 10px;
      opacity: 0.69;
      img {
        width: 100%;
      }
    }
    .state-text {
      font-size: 16px;
      white-space: pre-wrap;
      line-height: 22px;
    }
  }
}

.screenshot-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: #0000009f;
}

.el-sport-screenshot {
  position: relative;
  width: 1060px;
  img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 68px;
  }
  .el-swiper-button-prev {
    left: 0;
  }
  .el-swiper-button-next {
    right: 0;
  }
  .el-screenshot-box {
    position: relative;
    width: 960px;
    height: 540px;
    .swiper-slide {
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .el-screenshot-tag {
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px 20px;
        background: #4072ee;
        border-radius: 0 6px 0 0;
        color: #ffffff;
        span {
          display: inline-block;
          font-size: 10px;
          color: #ffffff;
          white-space: nowrap;
        }
      }
    }
  }
}

.wrap-text {
  font-size: 16px;
  white-space: pre-wrap;
  line-height: 20px;
}

.title-box {
  display: flex;
  align-items: center;
  img {
    width: 32px;
    height: 32px;
    margin-right: 8px;
  }
  span {
    font-size: 22px;
    font-weight: bold;
  }
}
</style>
